import { useCallback, useState } from 'react';

import environment from '../environment/environment';
import { getLocalScores, shouldStopTest, submitSettings } from '../utils/stopping-rules';

interface UseLoadLearnosityItemsSDKProps {
  allowedConsecutiveFails: number;
}

const useLoadLearnosityItemsSDK = (props?: UseLoadLearnosityItemsSDKProps) => {
  const [loading, setLoading] = useState(false);
  const [learnosityTestSubmitted, setLearnosityTestSubmitted] = useState(false);
  const [loadLearnosityTestError, setLoadLearnosityTestError] = useState(false);
  const getLearnositySDK = useCallback(
    (data: any) => {
      setLoading(true);
      const scriptjs = require('scriptjs');

      scriptjs(environment.REACT_APP_LEARNOSITY_ITEMS_SDK_URL, function () {
        const callbacks = {
          readyListener() {
            const sideMenu = document.querySelector('.lrn-region.lrn-right-region');
            if (sideMenu) {
              sideMenu?.parentNode?.removeChild(sideMenu);
            }
            setLoading(false);
          },
          errorListener(err: any) {
            console.log(err);
          },
        };

        const itemsApp = (window as any).LearnosityItems.init(
          JSON.parse(data.responseDataJson),
          callbacks,
        );

        itemsApp.on('test:submit:success', function () {
          setLearnosityTestSubmitted(true);
        });

        itemsApp.on('items:lazyload:error', function () {
          setLoadLearnosityTestError(true);
        });

        if (props?.allowedConsecutiveFails && props?.allowedConsecutiveFails > 0) {
          itemsApp.on('item:changing', function (itemIndex: number) {
            const scores = itemsApp.getScores();
            const localScores = getLocalScores(scores);

            const isSkippedQuestionAWrongQuestion = true; // this variable can be true only in `adaptive` learnosity tests, in other learnosity test types all questions would be returned by `itemsApp.getScores()` since the beggining of the test with a null value as the score
            const allowedConsecutiveFails = isSkippedQuestionAWrongQuestion
              ? props.allowedConsecutiveFails + 1 // `item:changing` is fired when a new question is shown, so the last question score is always null and we should desconsider it, else we would be counting it as a skipped question
              : props.allowedConsecutiveFails;

            if (
              shouldStopTest(localScores, allowedConsecutiveFails, isSkippedQuestionAWrongQuestion)
            ) {
              setLearnosityTestSubmitted(true);
              itemsApp.submit(submitSettings);
            }
          });
        }
      });
    },
    [props?.allowedConsecutiveFails],
  );

  return {
    loading,
    getLearnositySDK,
    learnosityTestSubmitted,
    loadLearnosityTestError,
  };
};

export default useLoadLearnosityItemsSDK;
